import colors from '@/styles/color.scss';
export const RoiType = {
    roi: {
        normal: {
            border: {
                width: 4,
                color: colors.roiColorsBorderNormal,
                transparent: true,
                opacity: 0.8,
            },
            polygon: {
                color: colors.roiColorsPolygonNormal,
                transparent: true,
                opacity: 0.3,
                show: true,
            },
            roiText: {
                size: 25,
                color: colors.roiColorsRoitextNormal,
            },
        },
        active: {
            border: {
                width: 4,
                color: colors.roiColorsBorderNormal,
                transparent: true,
                opacity: 0.8,
            },
            polygon: {
                color: colors.roiColorsPolygonActive,
                transparent: true,
                opacity: 0.3,
                show: true,
            },
            roiText: {
                size: 25,
                color: colors.roiColorsRoitextNormal,
            },
        },
    },
    hotArea: {
        normal: {
            border: {
                width: 4,
                color: colors.hotareaColorsBorderNormal,
                transparent: true,
                opacity: 0,
            },
            polygon: {
                color: colors.hotareaColorsPolygonNormal,
                transparent: true,
                opacity: 0,
                show: false,
            },
            roiText: {
                size: 25,
                color: colors.hotareaColorsRoitextNormal,
            },
        },
        active: {
            border: {
                width: 4,
                color: colors.hotareaColorsBordertActive,
                transparent: true,
                opacity: 0.8,
            },
            polygon: {
                color: colors.hotareaColorsPolygonNormal,
                transparent: true,
                opacity: 0,
                show: false,
            },
            roiText: {
                size: 25,
                color: colors.hotareaColorsRoitextActive,
            },
        },
    },
    idleParking: {
        normal: {
            border: {
                width: 0,
                color: colors.roiColorsBorderNormal,
                transparent: true,
                opacity: 0.8,
            },
            polygon: {
                color: colors.idleParkingColorsPolygonNormal,
                transparent: true,
                opacity: 0.3,
                show: true,
            },
        },
        active: {
            border: {
                width: 0,
                color: colors.roiColorsBorderNormal,
                transparent: true,
                opacity: 0.8,
            },
            polygon: {
                color: colors.idleParkingColorsPolygonActive,
                transparent: true,
                opacity: 0.3,
                show: true,
            },
        },
    },
    carParking: {
        normal: {
            border: {
                width: 4,
                color: colors.idleParkingColorsPolygonNormal,
                transparent: true,
                opacity: 1,
            },
            polygon: {
                color: colors.idleParkingColorsPolygonNormal,
                transparent: true,
                opacity: 0.6,
                show: true,
            },
        },
        active: {
            border: {
                width: 0,
                color: colors.idleParkingColorsBorder,
                transparent: true,
                opacity: 0.8,
            },
            polygon: {
                color: colors.idleParkingColorsPolygonActive,
                transparent: true,
                opacity: 0.3,
                show: true,
            },
        },
    },
    employParking: {
        normal: {
            border: {
                width: 0,
                color: colors.roiColorsBorderNormal,
                transparent: true,
                opacity: 0.8,
            },
            polygon: {
                color: colors.employParkingColorsPolygonNormal,
                transparent: true,
                opacity: 0.3,
                show: true,
            },
        },
        active: {
            border: {
                width: 0,
                color: colors.roiColorsBorderNormal,
                transparent: true,
                opacity: 0.8,
            },
            polygon: {
                color: colors.employParkingColorsPolygonActive,
                transparent: true,
                opacity: 0.3,
                show: true,
            },
        },
    },
    unknownParking: {
        normal: {
            border: {
                width: 4,
                color: colors.unknownParkingColorsPolygonNormal,
                transparent: true,
                show: true,
                dash: [10, 10]
            },
            polygon: {
                color: colors.unknownParkingColorsPolygon,
                transparent: true,
                show: true,
            },
        },
        active: {
            border: {
                width: 4,
                color: colors.unknownParkingColorsPolygonNormal,
                transparent: true,
                dash: []
            },
            polygon: {
                color: colors.unknownParkingColorsPolygon,
                transparent: true,
                show: true,
            },
        }
    },
    lotParking: {},
    fence: {}
};
export const HeatMapType = {
    critical: [
        {
            offset: 0,
            color: colors.heatmapCriticalNormal,
        },
        {
            offset: 1,
            color: colors.heatmapCriticalRadiation,
        },
    ],
    major: [
        {
            offset: 0,
            color: colors.heatmapMajorNormal,
        },
        {
            offset: 1,
            color: colors.heatmapMajorRadiation,
        },
    ],
    minor: [
        {
            offset: 0,
            color: colors.heatmapMinorNormal,
        },
        {
            offset: 1,
            color: colors.heatmapMinorRadiation,
        },
    ],
    normal: [
        {
            offset: 0,
            color: colors.heatmapMormalNormal,
        },
        {
            offset: 1,
            color: colors.heatmapMormalRadiation,
        },
    ],
    complex: [
        {
            offset: 0,
            color: colors.heatmapComplex0,
        },
        {
            offset: 0.7,
            color: colors.heatmapComplex1,
        },
        {
            offset: 1,
            color: colors.heatmapComplex2,
        },
    ],
};
